import { Menu, Modal, notification } from 'antd';
import { useContext } from 'react';
import { updateIssue } from '../../../api/issues';
import { ShieldContext } from '../context/shieldContext';

const { Item } = Menu;
const { confirm } = Modal;

const ChangeStatus = () => {
    const { issue, updateIssue: updateStatus } = useContext(ShieldContext);

    const OPTIONS = [
        { label: 'PENDING', value: 'PENDING' },
        { label: 'ACTIVE', value: 'ACTIVE' },
        { label: 'SOLVED', value: 'SOLVED' },
        { label: 'NOT SOLVED', value: 'NOT_SOLVED' },
    ];

    const confirmChangeStatus = (status: string) => confirm({
        title: 'Change status',
        content: 'Are you sure you want to change the status of this issue?',
        onOk: async () => {
            try {
                const payload = {
                    responsableID: issue?.responsableID,
                    responsableName: issue?.responsableName,
                    status,
                    description: issue?.description,
                    companyName: issue?.bookingData?.businessName,
                    userID: issue?.userID,
                    bookingNumericId: issue?.bookingNumericId,
                    issuePublicID: issue?.issuePublicID,
                    role: 'business',
                };
                const issueID = issue?._id;
                await updateIssue(issueID, payload);
                notification.success({
                    message: 'Status changed successfully',
                });
                updateStatus(issueID, { status });
            } catch (error) {
                console.log(error);
                notification.error({
                    message: 'Error',
                    description: 'Something went wrong, please try again later',
                });
            }
        },
        okText: 'Change',
        cancelText: 'Cancel',
    });

    return (
        <Menu>
            {
                OPTIONS.map((option) => (
                    <Item
                        key={option.value}
                        onClick={() => confirmChangeStatus(option.value)}
                    >
                        {option.label}
                    </Item>
                ))
            }
        </Menu>
    );
};

export default ChangeStatus;
